/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignAnalyticsDataSchema = z.object({
	candidateCount: z.number(),
	nonContactableCount: z.number(),
	submissionCount: z.number(),
	budget: z.number().nullable(),
	costPerCandidate: z.number().nullable(),
})

export type CampaignAnalyticsDataSchema = z.infer<typeof campaignAnalyticsDataSchema>
